const rawTitle = process.env.REACT_APP_TITLE_HEADING_NAME;
const rawCompanyLegal = process.env.REACT_APP_COMPANY_LEGAL_NAME;

export const TITLE_HEADING_NAME = (rawTitle || "").trim() || "DeliveryPlus";
export const COMPANY_LEGAL_NAME =
  (rawCompanyLegal || "").trim() || "Identifyplus Delivery Services Private Limited";
export const IS_BRAAZO = TITLE_HEADING_NAME.toLowerCase() === "braazo";
export const APP_LOGO_PUBLIC_SRC = IS_BRAAZO ? "/favicon2.jpeg" : "/favicon.ico";

